import React from 'react';
import Icon from '../../../components/AppIcon';
import { Card, CardContent } from '../../../components/ui/Card';
import { cn } from '../../../utils/cn';

const RegularizationStats = ({ stats }) => {
  const statCards = [
    {
      title: 'Pending Batches',
      value: stats.pendingBatches || 0,
      icon: 'Clock',
      color: 'warning',
    },
    {
      title: 'Batch Rectified',
      value: stats.completedBatches || 0,
      icon: 'CheckCircle',
      color: 'success',
    },
    {
      title: 'Expired Requests',
      value: stats.expiredRequests || 0,
      icon: 'XCircle',
      color: 'destructive',
    },
  ];

  const getColorScheme = (colorType) => {
    const schemes = {
      primary: { 
        bg: 'bg-gradient-to-br from-blue-50 to-blue-100/50', 
        iconBg: 'bg-gradient-to-br from-blue-500 to-blue-600',
        iconText: 'text-white',
        border: 'border-blue-200',
        accent: 'bg-blue-500'
      },
      success: { 
        bg: 'bg-gradient-to-br from-emerald-50 to-emerald-100/50', 
        iconBg: 'bg-gradient-to-br from-emerald-500 to-emerald-600',
        iconText: 'text-white',
        border: 'border-emerald-200',
        accent: 'bg-emerald-500'
      },
      warning: { 
        bg: 'bg-gradient-to-br from-amber-50 to-amber-100/50', 
        iconBg: 'bg-gradient-to-br from-amber-500 to-amber-600',
        iconText: 'text-white',
        border: 'border-amber-200',
        accent: 'bg-amber-500'
      },
      destructive: { 
        bg: 'bg-gradient-to-br from-red-50 to-red-100/50', 
        iconBg: 'bg-gradient-to-br from-red-500 to-red-600',
        iconText: 'text-white',
        border: 'border-red-200',
        accent: 'bg-red-500'
      },
    };
    return schemes[colorType] || schemes.primary;
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {statCards.map((stat, index) => {
        const colorScheme = getColorScheme(stat.color);
        return (
          <Card 
            key={index} 
            className={cn(
              "group relative overflow-hidden border transition-all duration-300 hover:-translate-y-1",
              "border-slate-200/80 shadow-sm hover:shadow-xl",
              "before:absolute before:inset-0 before:bg-gradient-to-br before:from-white/0 before:to-white/0 hover:before:from-white/5 hover:before:to-transparent before:transition-all before:duration-300"
            )}
          >
            {/* Accent bar */}
            <div className={cn("absolute top-0 left-0 right-0 h-1", colorScheme.accent)} />
            
            <CardContent className="p-4">
              <div className="flex items-center justify-between gap-3">
                <div className="flex items-center gap-3 flex-1 min-w-0">
                  {/* Icon */}
                  <div className={cn(
                    "relative p-2.5 rounded-lg shadow-sm flex items-center justify-center flex-shrink-0 transition-all duration-300 group-hover:scale-110 group-hover:shadow-md",
                    colorScheme.iconBg
                  )}>
                    <Icon name={stat.icon} size={18} className={colorScheme.iconText} />
                    <div className="absolute inset-0 rounded-lg bg-white/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                  </div>
                  
                  {/* Content */}
                  <div className="min-w-0 flex-1">
                    <p className="text-xs font-medium text-slate-500 mb-1 uppercase tracking-wide">{stat.title}</p>
                    <h3 className="text-2xl font-bold text-slate-900 tracking-tight">{stat.value}</h3>
                  </div>
                </div>
              </div>
            </CardContent>
            
            {/* Decorative gradient overlay */}
            <div className="absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-t from-slate-50/50 to-transparent pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
          </Card>
        );
      })}
    </div>
  );
};

export default RegularizationStats;
